<div class="labels-container">
    <!-- Given skills -->
    <div *ngFor="let givenSkill of givenSkills">
        <div
            [ngClass]="{
                'label-skill--given-highlight': givenSkill.highLight,
                'label-skill--given': !givenSkill.highLight
            }"
            class="label label-default label-skill"
        >
            {{ givenSkill.trainingName }} x{{ givenSkill.nbGiven }}
        </div>
    </div>

    <!-- Followed skills -->
    <div *ngFor="let followedSkill of followedSkills">
        <div
            [ngClass]="{
                'label-skill--followed-highlight': followedSkill.highLight,
                'label-skill--followed': !followedSkill.highLight
            }"
            class="label label-default label-skill"
        >
            {{ followedSkill.trainingName }}
        </div>
    </div>

    <!-- Wished skills -->
    <div *ngFor="let wishedSkill of wishedSkills">
        <div
            [ngClass]="{
                'label-skill--wished-highlight': wishedSkill.highLight,
                'label-skill--wished': !wishedSkill.highLight
            }"
            class="label label-default label-skill"
        >
            {{ wishedSkill.trainingName }}
            <i
                *ngIf="editable"
                (click)="deleteWishedSkill(wishedSkill)"
                class="fa fa-times"
                aria-hidden="true"
            ></i>
        </div>
    </div>

    <!-- Can skills -->
    <div *ngFor="let canSkill of canSkills">
        <div
            [ngClass]="{
                'label-skill--can-highlight': canSkill.highLight,
                'label-skill--can': !canSkill.highLight
            }"
            class="label label-default label-skill"
        >
            {{ canSkill.trainingName }}
            <i
                *ngIf="editable"
                (click)="deleteCanSkill(canSkill)"
                class="fa fa-times"
                aria-hidden="true"
            ></i>
        </div>
    </div>

    <!-- Can skills -->
    <div *ngFor="let refuseSkill of refuseSkills">
        <div
            [ngClass]="{
                'label-skill--refuse-highlight': refuseSkill.highLight,
                'label-skill--refuse': !refuseSkill.highLight
            }"
            class="label label-default label-skill"
        >
            {{ refuseSkill.trainingName }}
            <i
                *ngIf="editable"
                (click)="deleteRefuseSkill(refuseSkill)"
                class="fa fa-times"
                aria-hidden="true"
            ></i>
        </div>
    </div>
</div>



// WEBPACK FOOTER //
// ./src/app/_screens/_shared/label/label.component.html